"use strict";
var globalThis = require("../internals/global-this");
var globalIsFinite = globalThis.isFinite;
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == "number" && globalIsFinite(it);
};
